module.exports = __webpack_public_path__ + "assets/img/favicon.c63e8543dd679ca28d15df5d21feb9b7.png";